<template>
<div class="loading-background">
  <div class="inner-loading">
    <div class="preloader" :style="cssVars">
    <span class="rot-1"></span>
    <span class="rot-2"></span>
    <span class="rot-3"></span>
    <span class="rot-4"></span>
    <span class="rot-5"></span>
    <span class="rot-6"></span>
    <span class="rot-7"></span>
    <span class="rot-8"></span>
  </div>
  </div>

</div>

</template>

<script>
export default {
  name: 'Preloader',
  props: {
    color: {
      type: String,
      default: '#41b883',
    },
    scale: {
      type: String,
      default: 1,
    },
  },
  computed: {
    cssVars() {
      return {
        '--color': this.color,
        '--scale': this.scale,
      }
    }
  }
}
</script>

<style scoped>
.loading-background{
    position: absolute;
    width:100%;
    height: 100%;
    top: 0%;
    left:0;
    background: rgba(68, 65, 65, 0.479);
    z-index: 50;
    /* display:none; */

}
.inner-loading{
  position: relative;
  width: 100%;
  height: 100%;
}
.preloader {
  position: absolute;
  top: calc(50% - 65px);
  left: calc(50% - 65px);
  width: 125px;
  height: 125px;
  margin: auto;
  -webkit-transform: scale(var(--scale));
      -ms-transform: scale(var(--scale));
          transform: scale(var(--scale));
}
.preloader > span {
  position: absolute;
  background-color: transparent;
  height: 22px;
  width: 22px;
  border-radius: 12px;
  -webkit-animation-name: f_fadeG;
          animation-name: f_fadeG;
  -webkit-animation-duration: 1.2s;
          animation-duration: 1.2s;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  -webkit-animation-direction: normal;
          animation-direction: normal;
}
.rot-1 {
  left: 0;
  top: 51px;
  -webkit-animation-delay: 0.45s;
          animation-delay: 0.45s;
}
.rot-2 {
  left: 15px;
  top: 15px;
  -webkit-animation-delay: 0.6s;
          animation-delay: 0.6s;
}
.rot-3 {
  left: 51px;
  top: 0;
  -webkit-animation-delay: 0.75s;
          animation-delay: 0.75s;
}
.rot-4 {
  right: 15px;
  top: 15px;
  -webkit-animation-delay: 0.9s;
          animation-delay: 0.9s;
}
.rot-5 {
  right: 0;
  top: 51px;
  -webkit-animation-delay: 1.05s;
          animation-delay: 1.05s;
}
.rot-6 {
  right: 15px;
  bottom: 15px;
  -webkit-animation-delay: 1.2s;
          animation-delay: 1.2s;
}
.rot-7 {
  left: 51px;
  bottom: 0;
  -webkit-animation-delay: 1.35s;
          animation-delay: 1.35s;
}
.rot-8 {
  left: 15px;
  bottom: 15px;
  -webkit-animation-delay: 1.5s;
          animation-delay: 1.5s;
}
@-webkit-keyframes f_fadeG {
  0% {
    background-color: var(--color);
  }
  100% {
    background-color: transparent;
  }
}
@keyframes f_fadeG {
  0% {
    background-color: var(--color);
  }
  100% {
    background-color: transparent;
  }
}
</style>